<template>
  <section
    id="related"
    class="padding-top-5xl"
  >
    <div class="container">
      <div class="row roomy margin-bottom-xl">
        <div class="column-12 tablet:column-8 laptop:column-9">
          <h3 style="--margin-bottom: var(--spacing-3xs)">An Icon Collection Packed with Packs</h3>
          <p>{{ iconPack().label }} is one of several icon packs, each with a unique personality and pixel-perfectly designed.</p>
        </div>
        <div
          class="display-none tablet:display-block column-12 tablet:column-4 laptop:column-3 tablet:text-right"
          style="--button-hover-background: var(--theme-button-hover-background); --button-hover-border-color: var(--theme-button-hover-border-color)"
        >
          <site-link
            :to="{ name: 'latest.icons.packs' }"
            class="button flat with-border margin-bottom-0"
            style="--border-color: var(--fa-gravy); --button-background: transparent; --button-color: var(--fa-navy)"
            @click.native="$posthog.capture('pack_landing:all_packs_link_click', { pack: iconPack().name })"
          >
            <span class="display-none laptop:display-inline">View </span> All Packs
            <font-awesome-icon
              :icon="$v6.solid.faGrid2"
              fixed-width
              size="lg"
              class="margin-left-md"
            />
          </site-link>
        </div>
      </div>

      <icon-packs-list />
    </div>
  </section>
</template>

<script>
  import v7SaleMixin from 'app/views/v7SaleMixin'
  import IconPacksList from './IconPacksList'

  export default {
    name: 'PackIconList',

    components: {
      IconPacksList
    },

    mixins: [v7SaleMixin],

    inject: ['iconPack']
  }
</script>
